/* unplugin-vue-components disabled */import script from "./InvoiceTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTrigger.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTrigger.vue?vue&type=style&index=0&id=5ebf7062&lang=css"

const __exports__ = script;

export default __exports__